import { catchAll } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_PLAYERS_SLUG,
  FOOTBALL_BUNDLED_AUCTIONS_ID,
  FOOTBALL_CARDS_SLUG,
  FOOTBALL_CLUBS_SLUG,
  FOOTBALL_COUNTRIES_COUNTRYCODE,
  FOOTBALL_LEAGUES_SLUG,
  FOOTBALL_MARKET,
  FOOTBALL_MY_CLUB_SLUG_CARDS,
  FOOTBALL_SCOUTING_CENTER_STATS,
  FOOTBALL_SCOUTING_CENTER_WATCHLISTS,
} from '@sorare/core/src/constants/__generated__/routes';

import { MarketSubscriptions } from '@sorare/marketplace/src/components/MarketSubscriptions';

const AUCTION_SUBSCRIPTION_ROUTES = [
  FOOTBALL_CARDS_SLUG,
  FOOTBALL_BUNDLED_AUCTIONS_ID,
  catchAll(FOOTBALL_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(FOOTBALL_COUNTRIES_COUNTRYCODE),
  catchAll(FOOTBALL_LEAGUES_SLUG),
  catchAll(FOOTBALL_CLUBS_SLUG),
  catchAll(FOOTBALL_SCOUTING_CENTER_STATS),
  catchAll(FOOTBALL_SCOUTING_CENTER_WATCHLISTS),
];

const OFFERS_SUBSCRIPTION_ROUTES = [
  FOOTBALL_CARDS_SLUG,
  catchAll(FOOTBALL_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(FOOTBALL_COUNTRIES_COUNTRYCODE),
  catchAll(FOOTBALL_LEAGUES_SLUG),
  catchAll(FOOTBALL_CLUBS_SLUG),
  catchAll(FOOTBALL_MY_CLUB_SLUG_CARDS),
  catchAll(FOOTBALL_SCOUTING_CENTER_STATS),
  catchAll(FOOTBALL_SCOUTING_CENTER_WATCHLISTS),
];

const PRIMARY_OFFERS_SUBSCRIPTION_ROUTES = [
  FOOTBALL_CARDS_SLUG,
  catchAll(FOOTBALL_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(FOOTBALL_SCOUTING_CENTER_STATS),
  catchAll(FOOTBALL_SCOUTING_CENTER_WATCHLISTS),
];

export const FootballMarketSubscriptions = () => {
  return (
    <MarketSubscriptions
      sports={[Sport.FOOTBALL]}
      auctionsRoutes={AUCTION_SUBSCRIPTION_ROUTES}
      offersRoutes={OFFERS_SUBSCRIPTION_ROUTES}
      primaryOffersRoutes={PRIMARY_OFFERS_SUBSCRIPTION_ROUTES}
    />
  );
};
